import React, { useState, useEffect } from 'react';
import ListaOrdini from './DBperAreaOrdiniComponenti/ListaOrdini';
import BarraRicercaOrdini from './DBperAreaOrdiniComponenti/BarraRicercaOrdini';

function DBperAreaVisteSpeciali({
    ordine,
    setOrdineFunction,
    urlRicerca,
    setUrlRicerca,
    limiteRighe,
    setLimiteRighe,
    setResImport,
    totalRows,
    setTotalRows,
    perPage,
    setPerPage,
    page,
    setPage,
    urlParametri,
    setUrlParametri,
    datiTendineOrdine,
    ricerca,
    tema,
    utente,
    selezioneCampiRicerca,
    inputIniziale,
    setInputIniziale,
    columnSort,
    setColumnSort,
    directionSort,
    setDirectionSort,
    setQueryPRE,
    fetchOrdini,
    handlePageChange,
    handlePerRowsChange,
    handleSort,
    setRigheSelezionate,
    righeSelezionate,
    data,
    loading,
    deseleziona,
    setDeseleziona,
    setData,
    setRicerca,
    inputVuoto,
    vista,
    colonna,
    perPageOptions,
    setVista,
    urlRicercaINIT,
    ricercaIniz,
    mobile,
    setLoading,
    setGaranzia,
    setNuovaGaranzia,
    setListeOrdiniDaAltrove,
    funzioneScegliID,
    setVistaConReset
}) {

    useEffect(() => {
        console.log("DBperAreaVisteSpeciali fetch ordini")
        fetchOrdini(page);
    }, [vista]);

    return (
        <div class="center">
            <div class="cf">
                <div class="fl-ns w-100 w-100-ns w-100-m w-100-l pr4 pl3 bb bordoColAlt sfondoBiancoTema">
                    {mobile 
                    && righeSelezionate.length < 1 
                    && vista !== "anteprimaOrdiniGaranzie"
                    && <BarraRicercaOrdini
                        setListaOrdini={setData}
                        limiteRighe={limiteRighe}
                        setLimiteRighe={setLimiteRighe}
                        righeSelezionate={righeSelezionate}
                        setUrlRicerca={setUrlRicerca}
                        setOrdineFunction={setOrdineFunction}
                        setResImport={setResImport}
                        perPage={perPage}
                        page={page}
                        setTotalRows={setTotalRows}
                        urlParametri={urlParametri}
                        setUrlParametri={setUrlParametri}
                        datiTendineOrdine={datiTendineOrdine}
                        tema={tema}
                        selezioneCampiRicerca={selezioneCampiRicerca}
                        inputIniziale={inputIniziale}
                        ricerca={ricerca}
                        urlRicerca={urlRicerca}
                        setRicerca={setRicerca}
                        columnSort={columnSort}
                        directionSort={directionSort}
                        inputVuoto={inputVuoto}
                        setInputIniziale={setInputIniziale}
                        vista={"mobile2"}
                        setVista={setVista}
                        urlRicercaINIT={urlRicercaINIT}
                        ricercaIniz={ricercaIniz}
                        setPerPage={setPerPage}
                        mobile={false}
                        setLoading={setLoading}
                        setPage={setPage}
                        setGaranzia={setGaranzia}
                        setListeOrdiniDaAltrove={setListeOrdiniDaAltrove}
                        setVistaConReset={setVistaConReset}
                        utente={utente}
                        fetchOrdini={fetchOrdini}
                    />}
                    {righeSelezionate.length < 1 
                    && vista !== "anteprimaOrdiniGaranzie" && <BarraRicercaOrdini
                        setListaOrdini={setData}
                        limiteRighe={limiteRighe}
                        setLimiteRighe={setLimiteRighe}
                        righeSelezionate={righeSelezionate}
                        setUrlRicerca={setUrlRicerca}
                        setOrdineFunction={setOrdineFunction}
                        setResImport={setResImport}
                        perPage={perPage}
                        page={page}
                        setTotalRows={setTotalRows}
                        urlParametri={urlParametri}
                        setUrlParametri={setUrlParametri}
                        datiTendineOrdine={datiTendineOrdine}
                        tema={tema}
                        selezioneCampiRicerca={selezioneCampiRicerca}
                        inputIniziale={inputIniziale}
                        ricerca={ricerca}
                        urlRicerca={urlRicerca}
                        setRicerca={setRicerca}
                        columnSort={columnSort}
                        directionSort={directionSort}
                        inputVuoto={inputVuoto}
                        setInputIniziale={setInputIniziale}
                        vista={vista}
                        setVista={setVista}
                        urlRicercaINIT={urlRicercaINIT}
                        ricercaIniz={ricercaIniz}
                        setPerPage={setPerPage}
                        mobile={mobile}
                        setLoading={setLoading}
                        setPage={setPage}
                        setGaranzia={setGaranzia}
                        setNuovaGaranzia={setNuovaGaranzia}
                        setListeOrdiniDaAltrove={setListeOrdiniDaAltrove}
                        setVistaConReset={setVistaConReset}
                        utente={utente}
                        fetchOrdini={fetchOrdini}
                    />}
                </div>
                <div class="fl-ns w-100 w-100-ns pl2 pr2 sfondoBiancoTema">
                    <ListaOrdini
                        vista={vista}
                        setOrdineFunction={setOrdineFunction}
                        listaOrdini={data}
                        setListaOrdini={setData}
                        righeSelezionate={righeSelezionate}
                        setRigheSelezionate={setRigheSelezionate}
                        loading={loading}
                        totalRows={totalRows}
                        handlePerRowsChange={handlePerRowsChange}
                        handlePageChange={handlePageChange}
                        perPage={perPage}
                        deseleziona={deseleziona}
                        utente={utente}
                        handleSort={handleSort}
                        columnSort={columnSort}
                        directionSort={directionSort}
                        colonna={colonna}
                        perPageOptions={perPageOptions}
                        ricerca={ricerca}
                        page={page}
                        setGaranzia={setGaranzia}
                        funzioneScegliID={funzioneScegliID}
                        setVistaConReset={setVistaConReset}
                    />
                </div>
            {vista === "attese" && <p className='w-100 flex items-center justify-center'>
                <span className='b mr2'>Legenda</span>
                <div className='colTrovato pa2 b'>MERCE PRONTA, DA GESTIRE (CHIUNQUE)</div>
                <div className=' pa2 b'>NON ANCORA ASSEGNATO</div>
                <div className='colProntoExp pa2 b'>IN CORSO - STAI GESTENDO TU</div>
                <div className='colAttesa pa2 b'>GESTITO PER IL MOMENTO</div>                
            </p>}
            </div>
            
        </div>

    )
}


export default DBperAreaVisteSpeciali;
